export enum HistoricoControleAeracaoColunasEnum {
    DATA = 'data',
    CONTROLE = 'controle',
    USUARIO = 'usuario',
}
